import axios from 'axios'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import authService from '../../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1
} from '../../../Components/Main'
import ProfileDireita from '../../../Components/ProfileDireita'
import SidebarMobile from '../../../Components/SideBar-right/SidebarMobile'
import '../../../styles/pages/SubMenuPages/SubMenuTipoDeObservacao/SubMenuTipoDeObservacao.css'
import ModalEditar from './modalTiposDeObservacoes/modalEditarTipoDeObservacao'
import Modal from './modalTiposDeObservacoes/modalNovoTipoDeObservacao'
import '../../../styles/pages/MenuDireito/area.css'
// '../../Components/SideBar-right/SideBarDireita'

function Checklist() {
  var user = authService.getCurrentUser()
  const [modalInfo, setModalInfo] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')

  const [tiposDeObservacao, setTiposDeObservacoes] = useState<any[]>([])
  
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/observacaotipo/list/' +
          user[0].IdEmpresa
      )
      .then(response => {
        setTiposDeObservacoes(response.data)
      })
  }, [])
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }

  

  return (
    <div className="displayInteract">
      {modalOpen && (
        <ModalEditar setOpenModal={setModalOpen} modalInfo={modalInfo} />
      )}
      
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>
        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>
              CADASTRO DE CHECKLIST
            </TitlePage1>
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fCxPesquisa"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
            <Modal />
          </div>
        </div>
        <div className="tabelaPadrao">
            <table>
              <thead>
                <th style={{ textAlign: 'center'}}>
                  Grupos
                </th>
                <th style={{ textAlign: 'center'}}>
                  Estrutura
                </th>
                <th style={{ textAlign: 'center'}}>
                  Editar
                </th>
                <th>
                  Descrição da Observação
                </th>
                <th style={{ textAlign: 'center'}}>
                  fator(+)
                </th>
                <th style={{ textAlign: 'center'}}>
                  fator(-)
                </th>
                <th style={{ textAlign: 'center'}}>
                  fator(N)
                </th>
                <th style={{ textAlign: 'center'}}>
                  Permitir NA
                </th>
                <th style={{ textAlign: 'center'}}>
                  Ativo
                </th>
              </thead>
              <tbody>
            {tiposDeObservacao.filter(val => {
              if (searchTerm === ''){
                return val
              } else if (
                val.otpDescricao
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase())
              ) {
                return val
              }
            })
            .map(tipoObservacao => (
              <tr key={tipoObservacao.IdObservacaoTipo}>
                <td>
                  <Link to={'/checklistGrupoQuestoes/' + tipoObservacao.IdObservacaoTipo}>
                    <button className="btnPageGroupQuest">
                    <i className="fas fa-bars"></i>
                    </button>
                  </Link>
                </td>
                <td>
                  <Link to={'/checklistEstrutura/' + tipoObservacao.IdObservacaoTipo}>
                    <button className="btnPageGroupQuest">
                    <i className="fas fa-bars"></i>
                    </button>
                  </Link>
                </td>
                <td onClick={() => handleToggleComplete(tipoObservacao)}>
                    <button className="btnPageGroupQuest">
                    <i className="fas fa-edit"></i>
                    </button>
                </td>
                <td>
                  <label>
                  {tipoObservacao.otpDescricao}
                  </label>
                </td>
                <td style={{ textAlign: 'center'}}>
                  <label>
                    {tipoObservacao.otpFatorPositivo}
                  </label>
                </td>
                <td style={{ textAlign: 'center'}}>
                  <label>
                    {tipoObservacao.otpFatorNegativo}
                  </label>
                </td>
                <td style={{ textAlign: 'center'}}>
                  <label>{tipoObservacao.otpFatorNeutro}</label>
                </td>
                <td style={{ textAlign: 'center'}}>
                  <input
                      type="checkbox"
                      defaultChecked={!!tipoObservacao.otpPermitirNA}
                      disabled
                    />
                </td>
                <td style={{ textAlign: 'center'}}>
                <input
                      type="checkbox"
                      defaultChecked={!!tipoObservacao.otpStatus}
                      disabled
                    />
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
        </ContainerPage>
        <nav className="esconderFiltro">
        <ProfileDireita />
        {/* <NavDireita /> */}
            
        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default Checklist
